import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/api';

export default function VendorRiskList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const risk = searchParams.get('risk');
  const category = searchParams.get('category');
  const metric = searchParams.get('metric');

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const qs = searchParams.toString();

        const data = await api.get(
          `/vendors/risk-list?${qs}`
        );

        setRows(data.rows || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [searchParams]);

  const pageTitle =
    risk
      ? `${risk} Risk Vendors`
      : category
      ? category
      : metric
      ? `${metric.toUpperCase()} Analysis`
      : 'Vendor Risk List';
    const handleSort = (column) => {
  if (sortColumn === column) {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  } else {
    setSortColumn(column);
    setSortDirection("asc");
  }
};

const sortedRows = [...rows].sort((a, b) => {
  if (!sortColumn) return 0;

  let valueA = a[sortColumn];
  let valueB = b[sortColumn];

  if (valueA === null || valueA === undefined) valueA = "";
  if (valueB === null || valueB === undefined) valueB = "";

  if (typeof valueA === "string") {
    return sortDirection === "asc"
      ? valueA.localeCompare(valueB)
      : valueB.localeCompare(valueA);
  }

  return sortDirection === "asc"
    ? Number(valueA) - Number(valueB)
    : Number(valueB) - Number(valueA);
});

  return (
    <div className="space-y-4">

      <div className="flex items-center justify-between">

        <div>
          <h1 className="text-xl font-bold">
            {pageTitle}
          </h1>

          <p className="text-sm text-gray-500">
            Total Vendors : {rows.length}
          </p>
        </div>

        <button
          onClick={() =>
            navigate('/vendor-management/risk')
          }
          className="px-3 py-2 border rounded-lg"
        >
          Back
        </button>

      </div>

      <div className="bg-white rounded-xl border overflow-hidden">

        <table className="w-full text-sm">

        <thead>
  <tr className="bg-gray-50">

    <th className="px-4 py-3 text-left">
      Vendor Name
    </th>

    <th
  className="px-4 py-3 text-center cursor-pointer select-none"
  onClick={() => handleSort("Vendor_Rating")}
>
  Rating{" "}
  {sortColumn === "Vendor_Rating" &&
    (sortDirection === "asc" ? "▲" : "▼")}
</th>

    <th className="px-4 py-3 text-center">
      Risk
    </th>

    <th className="px-4 py-3 text-center">
      Category
    </th>

    <th
      className="px-4 py-3 text-center cursor-pointer select-none"
      onClick={() => handleSort("Delivery_Score")}
    >
      Delivery{" "}
      {sortColumn === "Delivery_Score" &&
        (sortDirection === "asc" ? "▲" : "▼")}
    </th>

    <th
      className="px-4 py-3 text-center cursor-pointer select-none"
      onClick={() => handleSort("Quality_Score")}
    >
      Quality{" "}
      {sortColumn === "Quality_Score" &&
        (sortDirection === "asc" ? "▲" : "▼")}
    </th>

    <th
      className="px-4 py-3 text-center cursor-pointer select-none"
      onClick={() => handleSort("Procurement_Score")}
    >
      Procurement{" "}
      {sortColumn === "Procurement_Score" &&
        (sortDirection === "asc" ? "▲" : "▼")}
    </th>

    <th
      className="px-4 py-3 text-center cursor-pointer select-none"
      onClick={() => handleSort("Financial_Score")}
    >
      Financial{" "}
      {sortColumn === "Financial_Score" &&
        (sortDirection === "asc" ? "▲" : "▼")}
    </th>

  </tr>
</thead>
          <tbody>

            {loading ? (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-10"
                >
                  Loading...
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-10"
                >
                  No vendors found
                </td>
              </tr>
            ) : (
              sortedRows.map((row, index) => (
                <tr
                  key={index}
                  className="border-t hover:bg-gray-50 cursor-pointer"
                  onClick={() =>
                    navigate(
                      `/vendor-management/risk/${encodeURIComponent(
                        row["Vendor Name"]
                      )}`
                    )
                  }
                >
                  <td className="px-4 py-3">
                    {row["Vendor Name"]}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {Number(
                      row.Vendor_Rating || 0
                    ).toFixed(2)}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {row.Risk_Level}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {row.Vendor_Category}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {Number(
                      row.Delivery_Score || 0
                    ).toFixed(2)}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {Number(
                      row.Quality_Score || 0
                    ).toFixed(2)}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {Number(
                      row.Procurement_Score || 0
                    ).toFixed(2)}
                  </td>

                  <td className="px-4 py-3 text-center">
                    {Number(
                      row.Financial_Score || 0
                    ).toFixed(2)}
                  </td>

                </tr>
              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}